export default __webpack_public_path__ + "static/media/about-01.d685c465.jpg";